var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-container',[_c('el-aside',{staticStyle:{"overflow-x":"hidden"},attrs:{"width":"250px"}},[_c('side-bar')],1),_vm._v(" "),_c('el-container',[_c('el-header',{staticStyle:{"padding":"0px"}},[_c('top-bar')],1),_vm._v(" "),_c('el-main',{staticClass:"main",staticStyle:{"background-color":"#f9f9f9"}},[_c('router-view')],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d7d1df7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home.vue
// module id = null
// module chunks = 